import React from 'react';
import { InputBase } from '@mui/material';
import { colors } from '@skyslope/utils';
export { colors };
/********************
 * TYPOGRAPHY
 *******************/
const fontFamilies = [
    'proxima-nova',
    'Montserrat',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    '"Helvetica Neue"',
    'Arial',
    'Roboto',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
];
const headingFontFamily = fontFamilies.join(', ');
export const typography = {
    h1: {
        fontFamily: headingFontFamily,
        fontWeight: 700,
        fontSize: '48px',
        letterSpacing: '-1.02px',
        color: colors.grey[900],
    },
    h2: {
        fontFamily: headingFontFamily,
        fontWeight: 700,
        fontSize: '40px',
        lineHeight: '48px',
        letterSpacing: '-0.85px',
        color: colors.grey[900],
    },
    h3: {
        fontFamily: headingFontFamily,
        fontWeight: 700,
        fontSize: '30px',
        lineHeight: '40px',
        letterSpacing: '-0.5px',
        color: colors.grey[900],
    },
    h4: {
        fontWeight: 700,
        fontSize: '30px',
        lineHeight: '40px',
        letterSpacing: '-0.28px',
        color: colors.grey[800],
    },
    h5: {
        fontWeight: 700,
        fontSize: '24px',
        lineHeight: '32px',
        color: colors.grey[800],
    },
    h6: {
        fontWeight: 700,
        fontSize: '19px',
        lineHeight: '24px',
        letterSpacing: '0.16px',
        color: colors.grey[800],
    },
    subtitle1: {
        fontWeight: 700,
        fontSize: '15px',
        lineHeight: '20px',
        letterSpacing: '1.85px',
        textTransform: 'uppercase',
        color: colors.grey[800],
    },
    subtitle2: {
        fontWeight: 500,
        fontSize: '19px',
        lineHeight: '24px',
        letterSpacing: '0.16px',
        color: colors.grey[800],
    },
    overline: {
        fontWeight: 700,
        fontSize: '13px',
        lineHeight: '16px',
        letterSpacing: '1.6px',
        textTransform: 'uppercase',
        color: colors.grey[800],
    },
    body1: {
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '24px',
        color: colors.grey[800],
    },
    body2: {
        fontWeight: 700,
        fontSize: '16px',
        lineHeight: '24px',
        color: colors.grey[800],
    },
    button: {
        fontWeight: 700,
        fontSize: '16px',
        lineHeight: '16px',
    },
    caption: {
        fontWeight: 500,
        fontSize: '13px',
        letterSpacing: '0.4px',
        lineHeight: '16px',
        color: colors.grey[800],
    },
};
/********************
 * ELEVATION
 *******************/
export const elevation = {
    normal: {
        0: 'none',
        1: 'inset 0  -1.5px 0 0 #E1E7ED, 0   1px  1px 0   rgba(0,32,64,0.07),  0  2px 1px -1px rgba(0,32,64,0.06),  0  1px 3px  0   rgba(0,32,64,0.07)',
        2: 'inset 0  -1.5px 0 0 #E1E7ED, 0   2px  2px 0   rgba(0,32,64,0.07),  0  3px 1px -2px rgba(0,32,64,0.06),  0  1px 5px  0   rgba(0,32,64,0.07)',
        3: 'inset 0  -1.5px 0 0 #E1E7ED, 0   3px  4px 0   rgba(0,32,64,0.07),  0  3px 3px -2px rgba(0,32,64,0.06),  0  1px 8px  0   rgba(0,32,64,0.07)',
        4: 'inset 0  -1.5px 0 0 #E1E7ED, 0   4px  5px 0   rgba(0,32,64,0.07),  0  1px 10px 0   rgba(0,32,64,0.06),  0  2px 4px -1px rgba(0,32,64,0.07)',
        6: 'inset 0  -1.5px 0 0 #E1E7ED, 0   6px 10px 0   rgba(0,32,64,0.07),  0  1px 18px 0   rgba(0,32,64,0.06),  0  3px 5px -1px rgba(0,32,64,0.07)',
        8: 'inset 0  -1.5px 0 0 #E1E7ED, 0   8px 10px 1px rgba(0,32,64,0.07),  0  3px 14px 2px rgba(0,32,64,0.06),  0  5px 5px -3px rgba(0,32,64,0.07)',
        9: 'inset 0  -1.5px 0 0 #E1E7ED, 0   9px 12px 1px rgba(0,32,64,0.07),  0  3px 16px 2px rgba(0,32,64,0.06),  0  5px 6px -3px rgba(0,32,64,0.07)',
        12: 'inset 0 -1.5px 0 0 #E1E7ED, 0  12px 17px 2px rgba(0,32,64,0.07),  0  5px 22px 4px rgba(0,32,64,0.06),  0  7px 8px -4px rgba(0,32,64,0.07)',
        16: 'inset 0 -1.5px 0 0 #E1E7ED, 0  12px 17px 2px rgba(0,89,218,0.04), 0  5px 22px 4px rgba(0,89,218,0.03), 0  7px 8px -4px rgba(0,89,218,0.04)',
        24: 'inset 0  1.5px 0 0 #E1E7ED, 0 -12px 17px 2px rgba(0,89,218,0.04), 0 -5px 22px 4px rgba(0,89,218,0.03), 0 -7px 8px -4px rgba(0,89,218,0.04)',
    },
    active: {
        6: 'inset  0 -1.5px 0 0 #DCEEFF, 0  6px 10px 0   rgba(0,89,218,0.07), 0 1px 18px 0   rgba(0,89,218,0.06), 0 3px 5px -1px rgba(0,89,218,0.07)',
        12: 'inset 0 -1.5px 0 0 #DCEEFF, 0 12px 17px 2px rgba(0,89,218,0.07), 0 5px 22px 4px rgba(0,89,218,0.06), 0 7px 8px -4px rgba(0,89,218,0.07)',
    },
};
const materialShadows = [
    elevation.normal[0],
    elevation.normal[1],
    elevation.normal[2],
    elevation.normal[3],
    elevation.normal[4],
    elevation.normal[4],
    elevation.normal[6],
    elevation.normal[6],
    elevation.normal[8],
    elevation.normal[9],
    elevation.normal[9],
    elevation.normal[9],
    elevation.normal[12],
    elevation.normal[12],
    elevation.normal[12],
    elevation.normal[12],
    elevation.normal[16],
    elevation.normal[16],
    elevation.normal[16],
    elevation.normal[16],
    elevation.normal[16],
    elevation.normal[16],
    elevation.normal[16],
    elevation.normal[16],
    elevation.normal[24],
];
/********************
 * MUI OVERRIDES
 *******************/
export const macheTheme = {
    typography: {
        fontFamily: fontFamilies.join(','),
        ...typography,
    },
    shadows: materialShadows,
    palette: {
        primary: {
            light: colors.blue[600],
            main: colors.blue[800],
            dark: colors.blue[900],
            contrastText: '#fff',
        },
        grey: colors.grey,
        error: {
            light: colors.red[300],
            main: colors.red[400],
            dark: colors.red[500],
        },
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableRipple: false,
                color: 'primary',
            },
            styleOverrides: {
                root: {
                    padding: '14px 24px',
                    borderRadius: 9999,
                    textTransform: 'none',
                },
                outlined: {
                    border: `2px solid ${colors.blue[800]}`,
                    color: colors.blue[800],
                    padding: '10px 24px',
                    '&:hover': {
                        backgroundColor: colors.blue[50],
                        border: `2px solid ${colors.blue[800]}`,
                    },
                    '&:focus, &:active': {
                        backgroundColor: '#fff',
                    },
                    '&:disabled': {
                        color: colors.grey[500],
                        border: `2px solid ${colors.grey[500]}`,
                    },
                },
                outlinedSecondary: {
                    color: colors.grey[800],
                    borderColor: colors.grey[800],
                    '&:hover': {
                        borderColor: colors.grey[800],
                    },
                },
                contained: {
                    boxShadow: 'none !important',
                    '&:disabled': {
                        color: '#fff',
                        background: colors.grey[500],
                        boxShadow: 'none',
                    },
                },
                containedPrimary: {
                    background: `linear-gradient(to right, hsl(251 48% 48%), hsl(207, 93%, 52%))`,
                    color: '#fff',
                    boxShadow: 'none',
                    '&:hover': {
                        background: 'linear-gradient(to right, hsl(251 48% 55%), hsl(207, 93%, 59%))',
                        boxShadow: 'none',
                    },
                    '&:focus, &:active': {
                        backgroundColor: `${colors.blue[900]} !important`,
                    },
                },
                containedSecondary: {
                    backgroundColor: colors.grey[100],
                    color: colors.blue[800],
                    '&:hover': {
                        backgroundColor: colors.blue[50],
                    },
                },
                text: {
                    '&:hover': {
                        backgroundColor: colors.blue[50],
                    },
                },
                textSecondary: {
                    color: colors.grey[800],
                },
                sizeSmall: {
                    fontSize: `${16 / 16}rem`,
                    padding: '6px 8px',
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                variant: 'standard',
            },
        },
        MuiInput: {
            defaultProps: {
                disableUnderline: true,
            },
            styleOverrides: {
                root: {
                    transition: 'all 0.25s',
                    borderBottom: `2px solid ${colors.grey[600]}`,
                    marginTop: '0 !important',
                    '&.Mui-disabled': {
                        backgroundColor: colors.grey[300],
                        borderColor: colors.grey[400],
                    },
                    '&.Mui-focused': {
                        borderColor: colors.blue[800],
                    },
                },
            },
        },
        MuiFilledInput: {
            defaultProps: {
                disableUnderline: true,
            },
            styleOverrides: {
                root: {
                    backgroundColor: '#fff !important',
                    border: `1px solid ${colors.grey[400]}`,
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0,
                    transition: 'all 0.25s',
                    '&:hover': {
                        backgroundColor: '#fff',
                    },
                    '&.Mui-focused': {
                        boxShadow: elevation.active[6],
                        backgroundColor: '#fff',
                        borderBottom: `2px solid ${colors.blue[800]}`,
                        paddingBottom: '7px', // to prevent size change from the extra border size
                    },
                    '&.Mui-disabled': {
                        backgroundColor: `${colors.grey[50]} !important`,
                        borderColor: colors.grey[400],
                    },
                    '&.Mui-error': {
                        borderBottom: `2px solid ${colors.red[500]}`,
                        paddingBottom: '7px',
                    },
                },
                multiline: {
                    padding: 0,
                    '&.Mui-focused': {
                        paddingBottom: 0,
                        marginBottom: '-1px',
                    },
                },
                inputMultiline: {
                    padding: '8px 16px',
                },
                input: {
                    padding: 0,
                    '&.Mui-disabled': {
                        color: `${colors.grey[800]} !important`,
                        '-webkitTextFillColor': `${colors.grey[800]} !important`,
                    },
                },
            },
        },
        MuiInputLabel: {
            defaultProps: {
                variant: 'outlined',
            },
            styleOverrides: {
                root: {
                    ...typography.body1,
                    position: 'relative !important',
                    '&.Mui-focused': {
                        color: colors.blue[800],
                    },
                    '&.Mui-disabled': {
                        color: colors.grey[800],
                    },
                },
                // These prevent the animation of the MUI input label when the
                // user focuses the input.
                filled: { transform: 'none' },
                outlined: { transform: 'none' },
                standard: { transform: 'none' },
            },
        },
        MuiSelect: {
            defaultProps: {
                input: React.createElement(InputBase),
                variant: 'standard',
            },
            styleOverrides: {
                standard: {
                    borderBottom: `2px solid ${colors.grey[600]}`,
                },
                select: {
                    margin: '-8px -16px',
                    padding: '8px 24px 8px 16px',
                    transition: 'all 0.25s',
                    '&:focus': {
                        borderColor: colors.grey[400],
                        borderBottom: `2px solid ${colors.blue[800]}`,
                        paddingBottom: '7px', // to prevent size change from the extra border size
                    },
                    '&.Mui-disabled': {
                        backgroundColor: colors.grey[300],
                        borderColor: colors.grey[400],
                    },
                },
                filled: {
                    backgroundColor: '#fff',
                    border: `1px solid ${colors.grey[400]}`,
                },
            },
        },
        MuiNativeSelect: {
            styleOverrides: {
                icon: {
                    color: colors.grey[600],
                },
                select: {
                    borderBottom: 0,
                    '&:focus': {
                        borderColor: colors.blue[800],
                        backgroundColor: 'none !important',
                    },
                },
                filled: {
                    backgroundColor: '#fff',
                    border: `1px solid ${colors.grey[400]}`,
                    '&:focus': {
                        boxShadow: elevation.active[6],
                        borderColor: colors.grey[400],
                        borderBottom: `2px solid ${colors.blue[800]}`,
                        paddingBottom: '7px', // to prevent size change from the extra border size
                    },
                },
            },
        },
        MuiPaper: {
            defaultProps: {
                square: true,
                elevation: 12,
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    color: colors.grey[800],
                    fontSize: '13px',
                    fontWeight: 500,
                    lineHeight: '16px',
                    marginTop: '4px',
                },
                contained: {
                    margin: '4px 0 0 0',
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontSize: '17px',
                    fontWeight: 500,
                    lineHeight: '24px',
                    padding: '8px 16px',
                    color: colors.grey[900],
                    '&.Mui-disabled': {
                        color: colors.grey[500],
                    },
                },
                input: {
                    padding: 0,
                    '&::placeholder': {
                        color: colors.grey[500],
                        opacity: 1,
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    margin: '-8px -16px',
                    padding: '8px 24px 8px 16px',
                    transition: 'all 0.25s',
                    borderBottom: `2px solid ${colors.grey[600]}`,
                    '&.Mui-disabled': {
                        backgroundColor: colors.grey[300],
                        borderColor: colors.grey[400],
                    },
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                list: {
                    padding: 0,
                },
                paper: {
                    boxShadow: elevation.active[12],
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    padding: '8px 16px',
                    height: 40,
                    color: colors.grey[800],
                    '&:hover': {
                        backgroundColor: colors.blue[50],
                        color: colors.blue[800],
                        '& div': {
                            // target any icons or text that are a child of the menu item component
                            color: colors.blue[800],
                        },
                    },
                    '&.Mui-selected': {
                        color: '#fff',
                        backgroundColor: colors.blue[800],
                        '&:hover': {
                            backgroundColor: colors.blue[600],
                            '& div': {
                                // target any icons or text that are a child of the menu item component
                                color: '#fff',
                            },
                        },
                        '& div': {
                            // target any icons or text that are a child of the menu item component
                            color: '#fff',
                        },
                    },
                },
            },
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    color: colors.grey[500],
                },
                positionStart: {
                    marginLeft: '-8px',
                    marginTop: '0 !important', // filled input puts margin top here
                },
                positionEnd: {
                    marginRight: '-8px',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    boxShadow: elevation.normal[16],
                },
            },
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#fff',
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: '4px',
                    backgroundColor: colors.grey[600],
                    height: 'auto',
                },
                label: {
                    color: '#fafdff',
                    paddingTop: '4px',
                    paddingBottom: '4px',
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                fontSizeSmall: {
                    verticalAlign: 'text-top',
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    paddingTop: 0,
                    paddingBottom: '16px',
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    lineHeight: 1,
                },
            },
        },
    },
};
